<script setup>
import Rating from '../Rating.vue'
import ReachabilityStatus from './ReachabilityStatus.vue'

defineProps({
    contact: {
        type: Object,
        required: true,
    },
    reachability: {
        type: Object,
        required: true,
    },
})

const rating = window.CursusGeregeld.rating
</script>

<template>
    <div class="bg-red-700 py-2.5 text-white">
        <div class="container max-w-7xl flex items-center justify-between gap-6">
            <ul role="list" class="flex items-center gap-6 lg:gap-10 text-xs md:text-sm font-medium">
                <li>
                    <a :href="`tel:${contact.phoneNumber}`" class="flex items-center gap-2 rounded-sm transition-opacity hover:opacity-80 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white">
                        <icon name="phone" class="size-4"></icon>
                        <span><span class="sr-only">Bel ons: </span>{{ contact.phoneNumber }}</span>
                    </a>
                </li>
                <li class="hidden md:block">
                    <a :href="`mailto:${contact.email}`" class="flex items-center gap-2 rounded-sm transition-opacity hover:opacity-80 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white">
                        <icon name="mail" class="size-4"></icon>
                        <span><span class="sr-only">Mail ons: </span>{{ contact.email }}</span>
                    </a>
                </li>
            </ul>

            <ReachabilityStatus :status="reachability" class="hidden lg:inline-flex text-xs text-white/90" />

            <div class="lg:hidden flex items-center rounded-full bg-white py-1 pl-2 pr-3">
                <Rating :rating="rating" />
            </div>
        </div>
    </div>
</template>
